/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Group, ContentType, CTAs, Button, ToolTip } from '@insticator/insticator-ui'; // iui-material
import Status from 'material/embeds/status/status';
import QuestionBasedContentAnalyticsCard from 'material/embeds/contentanalyticscard/questionbased/questionbased';
import StoryContentAnalyticsCard from 'material/embeds/contentanalyticscard/story/story_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/contentanalyticscard/contentanalyticscard_styles';



/* ========== ~~~~~~~~~~ EMBED : CONTENT ANALYTICS CARD ~~~~~~~~~~ ========== */
class ContentAnalyticsCard extends Component {
    constructor(props) {
        super(props);
        this.state = { editContentClicked: false };
    }
    renderContent = () => {
        switch (this.props.content.contentType) {
            case 'story':
                return <StoryContentAnalyticsCard content={this.props.content} contentDetail={this.getContentDetail()} />;
            default:
                return <QuestionBasedContentAnalyticsCard content={this.props.content} contentDetail={this.getContentDetail()} />
        }
    };
    editContent = () => {
        this.setState({ editContentClicked: true });
        this.props.engageEditor();
        this.props.getEmbedEdit(this.props.embedUUID, this.props.content.contentId)
        // this.props.moveToContentEdit(this.props.content.contentId)
    };
    getContentDetail = () => this.props.content.contentType === "story" ? this.props.content.story : this.props.content.questionBased;
    renderTotalAnswers = () => (this.props.content.contentType !== "story" ? <div className={`total`}>
        Total Answers:  <span className={`totalnumber`}>{this.getContentDetail().totalNumberAnswered}</span> </div> : null)
    renderEditButton = () => (this.props.editPermitted ?
        <CTAs>
            <Button
                type={`action`}
                text={`Edit`}
                variant={`control`}
                action={this.editContent}
                name={`edit`}
                disabled={!this.props.content.contentLive || typeof this.props.content.queuePosition !== 'number'}
                operation={`load`}
                processing={this.state.editContentClicked}
            />
        </CTAs> : null);
    showText = () => this.props.content.contentLive ? 'online' : 'offline';
    render() {
        const editClicked = this.props.navigatingToEditor && !this.state.editContentClicked;
        return (
            <div className={`contentanalyticscard ${this.props.classes.contentanalyticscard} disabled-${editClicked}`}>
                <Group name={`identity`}>
                    <ContentType type={this.props.content.contentType} indicatorType={`indicator`} isLive={true} />
                    <ToolTip position={`top`} action={`mouseenter`} content={this.showText()}>
                        <div className={'status'}>
                            <Status live={this.props.content.contentLive} variant={`dot`} type={`indicator`} />
                            <span className={`text`}>{this.showText()}</span>
                        </div>
                    </ToolTip>
                </Group>
                {this.renderContent()}
                <Group name={`trailing`}>
                    {this.renderTotalAnswers()}
                    {this.renderEditButton()}
                </Group>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ContentAnalyticsCard);
